export const customLocale = {
  playModeText: {
    order: 'Tocar em ordem',
    orderLoop: 'Loop infinito',
    singleLoop: 'Loop único',
    shufflePlay: 'Aleatório'
  },
  openText: 'ABRIR',
  closeText: 'Fechar',
  emptyText: 'Sem músicas',
  clickToPlayText: 'Clique para tocar',
  clickToPauseText: 'Clique para pausar',
  nextTrackText: 'Próxima',
  previousTrackText: 'Anterior',
  reloadText: 'Recarregar',
  volumeText: 'Volume',
  playListsText: 'Playlists',
  toggleLyricText: '',
  toggleMiniModeText: 'modo Mini',
  destroyText: 'Fechar player',
  downloadText: 'Baixar',
  lightThemeText: '',
  darkThemeText: '',
  switchThemeText: '',
  removeAudioListsText: 'Apagar lista',
  controllerTitle: ''
}
